import React from 'react';
import { Breadcrumb, Panel } from 'rsuite';
import DataTable from './DataTable';
import NavLink from '@/components/NavLink';
import { useTranslation } from 'react-i18next';



const DepartmentPage = () => {
  const { t } = useTranslation();



  return (
    <Panel
      header={
        <>
          <h3 className="title">{t('Teams')}</h3>
          <Breadcrumb>
            <Breadcrumb.Item to="/" as={NavLink}>
              {t('Home')}
            </Breadcrumb.Item>
            <Breadcrumb.Item active>{t('Teams')}</Breadcrumb.Item>
          </Breadcrumb>
        </>
      }
    >
      <DataTable />
    </Panel>
  );
};

export default DepartmentPage;
